import '../../styles/templates/product.scss';
import { docReady } from '../helpers/docReady';
docReady(() => {
    // console.log('Product Template');
});
